// extracted by mini-css-extract-plugin
export default {"input":"Search_input__klILD","icon":"Search_icon__XMmYc","root":"Search_root__eiX89","closeBtn":"Search_closeBtn__+RB92"};